import $ from 'jquery'
import Cookies from 'js-cookie';
import floatLabel from '../directives/form/float-label';

let tempId = 0

export default function hsFormSection() {
	$('form.hs-form').each(async function () {
		const $form = $(this)
		const $cols = $('<div class="columns -h-gap-sm -v-gap-sm"></div>')
		let form

		const hapiKey = $form.attr('hs-api-key')
		const portalId = $form.attr('hs-portal-id')
		const formGuid = $form.attr('hs-form-guid')
		const recaptchaCallback = $form.attr('sw-recaptcha')
		const recaptchaSiteKey = $form.attr('sw-recaptcha-sitekey')

		const hubspotFormEndpoint = `${window.location.origin}/hubspot-form`

		const formData = new FormData()
		formData.append(csrfTokenName, csrfTokenValue)
		formData.append('formGuid', formGuid)

		$form.append($cols)
		$form.on('submit', handleFormSubmit)

		const response = await fetch(hubspotFormEndpoint, {
			method: 'POST',
			headers: {
				'Accept': 'application/json'
			},
			body: formData
		})


		try {
			form = await response.json()

			let $lastCol
			let richTextFlag

			form.formFieldGroups.forEach(group => {
				let $col
				const widthClass = `@desk-${group.fields.length === 2 ? '6' : '12'}`

				if (group.fields.length) {
					group.fields.forEach(field => {
						$col = $(`<div class="column ${widthClass}"></div>`)
						$cols.append($col)
						richTextFlag = false

						if (field.fieldType === 'text') {
							$col.append(getInputField(field))
						} else if (field.fieldType === 'textarea') {
							$col.append(getTextareaField(field))
						} else if (field.fieldType === 'radio') {
							$col.append(getRadioSelectField(field))
						} else if (field.fieldType === 'checkbox') {
							$col.append(getCheckboxField(field))
						} else if (field.fieldType === 'select') {
							$col.append(getRadioSelectField(field))
						}
					})
				}

				if (group.richText && group.richText.content) {
					if (richTextFlag) {
						$col = $lastCol
					} else {
						$col = $(`<div class="column ${widthClass} text"></div>`)
						$cols.append($col)
					}
					$col.append(`
						<div class="container -width-9 -align-left">
							<div class="text +text-left">
								${group.richText.content}
							</div>
						</div>
					`)

					richTextFlag = true
					$lastCol = $col
				}

				$lastCol = $col
			})

			// Add submit button with recaptcha if defined
			$cols.append(`
			  <div class="column @desk-12">
				<button
				  type="submit" 
				  class="button${(recaptchaCallback.length && recaptchaSiteKey.length) ? ' g-recaptcha' : ''}"
				  data-sitekey="${recaptchaSiteKey}"
				  data-callback="${recaptchaCallback}"
				>
				  Submit
				</button>
			  </div>
			`)

			// Initialize the new sw-float-labels
			floatLabel(document.body)

			// Hook up recaptcha
			if (recaptchaCallback.length && window.loadRecaptcha) {
				window.loadRecaptcha()
			}
		} catch (e) {
			// Could not resolve JSON for this form
		}

		async function handleFormSubmit(e) {
			e.preventDefault()
			const hubspotFormEndpoint = `${window.location.origin}/hubspot-form-submit`
			let currentFormData = $form.serializeArray();

			// if (Cookies.get('hubspotutk')) {
			// 	currentFormData.push({
			// 		name: 'hs_context',
			// 		value: JSON.stringify({
			// 			hutk: Cookies.get('hubspotutk')
			// 		})
			// 	});
			// }

			// Pull out the recaptcha response
			const grecaptchaResponse = currentFormData.filter(d => {
				return d.name === 'g-recaptcha-response'
			})[0].value

			// Convert to a query string for posting
			currentFormData = $.param(currentFormData)

			const formData = new FormData()
			formData.append(csrfTokenName, csrfTokenValue)
			formData.append('portalId', portalId)
			formData.append('formGuid', formGuid)
			formData.append('g-recaptcha-response', grecaptchaResponse)
			formData.append('formData', currentFormData)

			if (Cookies.get('hubspotutk')) {
				formData.append('cookieValue', Cookies.get('hubspotutk'))
			}

			formData.append('pageTitle', document.title)
			formData.append('pageUrl', window.location.origin + window.location.pathname)

			disableForm($form);

			try {
				const response = await fetch(hubspotFormEndpoint, {
					method: 'POST',
					headers: {
						'Accept': 'application/json'
					},
					body: formData
				})

				const json = await response.json()

				// If HubSpot redirects us to a CommsGroup url, take us to the location
				const locationStr = String(json.location);
				if (locationStr.includes('commsgroup.global')) {
					// if it's the contact thank you page then remove all params.
					if (locationStr.includes('?submissionGuid')) {
						window.location.href = locationStr.split('?submissionGuid')[0]
					} else {
						window.location.href = json.location
					}
					return
				}

				// If the returned status from HubSpot is a 2xx then display the
				// inlineMessage after the form
				if (json.status >= 200 && 299 >= json.status) {
					$form.after(getMessage(form.inlineMessage))
				} else {
					// Throw to re-enable the form since the form did now submit
					throw new Error(json.error)
				}
			} catch (e) {
				// Errored so dump a console warning
				console.warn(`Hubspot form submission failed at ${window.location.href}. ${e.message}.`)
				enableForm($form)
			}
		}
	})
}

function disableForm($form) {
	$form.addClass('is-posting')
	$form.find('input, textarea').attr('readonly')
}

function enableForm($form) {
	$form.removeClass('is-posting')
	$form.find('input, textarea').removeAttr('readonly')
}

const submitButton = `
	<div class="column @desk-12">
		<button type="submit" class="button">Submit</button>
	</div>
`

function getMessage(message) {
	return `
		<div class="columns -h-gap-sm -v-gap-sm">
			<div class="column @desk-12 text"></div>
				<div class="container -width-9 -align-left">
					<div class="text +text-left">
						${message}
					</div>
				</div>
			</div>
		</div>
	`
}

function getTextareaField(field) {
	tempId++
	return $(`
		<div sw-float-label class="float-label -type-textarea is-invalid">
			<label class="float-label_label" for="${tempId}">${field.label}</label>
			<textarea
				class="float-label_field"
				id="${tempId}"
				name="${field.name}"
				${field.required ? 'required' : ''}
				rows="4"
				spellcheck="false"
				sw-autosize
			></textarea>
		</div>
	`)
}

function getInputField(field) {
	tempId++
	let type = field.type
	let pattern

	if (field.name === 'email') {
		type = 'email'
		pattern = `^[a-zA-Z0-9!#$%&'*+/=?^_‘{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_‘{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$`
	} else if (field.name === 'phone') {
		type = 'tel'
		pattern = `^[+]?[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]{7,15}$`
	}

	return $(`
		<div sw-float-label class="float-label -type-text -type-input is-invalid">
			<label class="float-label_label" for="${tempId}">
				${field.label}
			</label>
			<input
				class="float-label_field"
				id="${tempId}"
				name="${field.name}"
				type="${type}"
				${field.required ? 'required' : ''}
				${pattern ? `pattern="${pattern}"` : ''}
			/>
		</div>
	`)
}

function getRadioSelectField(field) {
	tempId++
	return $(`
		<div sw-float-label class="float-label -type-select is-filled">
			<label class="float-label_label" for="${tempId}">
				${field.label}
			</label>

			<select
				class="float-label_field"
				id="${tempId}"
				name="${field.name}"
				required
			>
				<option selected></option>

				${field.options.map(option => `
					<option value="${option.value}">${option.label}</option>
				`).join('')}
			</select>

			<span class="float-label_arrow">
				<i aria-hidden="true" class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g id="Outline_Icons"><polygon fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="0.501,2.5    23.501,2.5 12.001,21.5  "></polygon></g><g id="Frames-24px"><rect fill="none" width="24" height="24"></rect></g></svg></i>
			</span>
		</div>
	`)
}

function getCheckboxField(field) {
	return $(`
		<div class="bar -h-gap-sm -h-align-left">
			<label class="float-label_label +t-margin-sm +b-margin-xs">
				${field.label}
			</label>
		</div>
		<div class="bar -h-gap-sm -h-align-left">
			${field.options.map(option => {
		tempId++
		return `
					<div class="item">
						<div class="checkbox">
							<input
								id="${tempId}"
								type="checkbox"
								name="${field.name}"
								value="${option.label}"
							/>
							<label for="${tempId}">
								<span class="checkbox_marker">
									<i aria-hidden="true" class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g id="Outline_Icons_1_"><g id="Outline_Icons"><g><polygon fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" points="20,2.25 7.5,14.75 4,11.25      0.5,14.75 7.5,21.75 23.5,5.75    "></polygon></g></g><g id="New_icons_1_"></g></g><g id="Invisible_Shape"><rect fill="none" width="24" height="24"></rect></g></svg></i>
								</span>
								<span class="checkbox_label">${option.label}</span>
							</label>
						</div>
					</div>
				`
	}).join('')}
		</div>
	`)
}



// WEBPACK FOOTER //
// ./source/scripts/sections/hsForm.js